var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { colors } from './styles/colors';
import { space } from './styles/space';
import { fonts } from './styles/fonts';
import size from './styles/size';
export var breakpoints = [
    size.mobileS,
    size.mobileL,
    size.tablet,
    size.laptop,
];
export var defaultTheme = {
    space: __assign({}, space),
    breakpoints: breakpoints,
    colors: __assign({}, colors),
    fonts: __assign({}, fonts),
};
